import React from "react"
import styles from "./input.module.css"

export function PasswordEyeIcon({showPassword}: {showPassword: boolean}): JSX.Element {
    return showPassword ? (
        // Eye-off icon
        <svg
            className={styles.toggleIcon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path
                d="M10.58 10.58C10.21 10.95 10 11.45 10 12C10 13.1 10.9 14 12 14C12.55 14 13.05 13.79 13.42 13.42"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M9.88 5.08C10.56 4.76 11.28 4.5 12 4.5C17 4.5 20.5 12 20.5 12C20.14 12.79 19.65 13.66 19.04 14.49"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M6.16 6.16C3.93 7.73 2.5 10.27 2.5 12C2.5 12 6 19.5 12 19.5C13.72 19.5 15.23 18.8 16.5 17.8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    ) : (
        // Eye icon
        <svg
            className={styles.toggleIcon}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 12C2 12 5.5 4.5 12 4.5C18.5 4.5 22 12 22 12C22 12 18.5 19.5 12 19.5C5.5 19.5 2 12 2 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
